import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import HomePage from './pages/HomePage';
import BranchPage from './pages/BranchPage';
import ContactPage from './pages/ContactPage';
import ProgramPage from './pages/ProgramPage';
import MediaGalleryPage from './pages/MediaGalleryPage';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/program" element={<ProgramPage />} />
        <Route path="/cabang" element={<BranchPage />} />
        <Route path="/media" element={<MediaGalleryPage />} />
        <Route path="/kontak" element={<ContactPage />} />
        {/* Add more routes as needed */}
        <Route path="*" element={<HomePage />} />
      </Routes>
    </Router>
  );
}

export default App;
